export const readerSections = [
  {
    id: 'engineers',
    title: 'Engineers',
    description:
      'Engineers can gain practical insights, coding tips, and real-world problem-solving techniques from Fernsology’s articles.',
  },
  {
    id: 'project-managers',
    title: 'Project Managers',
    description:
      'Project Managers can learn about efficient project workflows, team coordination, and planning strategies shared in the articles.',
  },
  {
    id: 'software-architects',
    title: 'Software Architects',
    description:
      'Software Architects can explore scalable system designs, architecture patterns, and best practices through detailed write-ups.',
  },
  {
    id: 'designers-ux',
    title: 'Designers & UX Thinkers',
    description:
      'Designers & UX Thinkers can find inspiration for user interfaces, UX strategies, product thinking and creative problem-solving in the articles.',
  },
  {
    id: 'founders-builders',
    title: 'Founders & Builders',
    description:
      'Founders & Builders can learn about product ideation, growth strategies, and turning ideas into tangible projects.',
  },
  {
    id: 'technical-writers',
    title: 'Technical Writers',
    description:
      'Technical Writers can improve documentation skills, writing clarity, content structuring and architecting information from practical examples in the articles.',
  },
  {
    id: 'developer-advocates',
    title: 'Developer Advocates',
    description:
      'Developer Advocates can discover ways to engage communities, communicate tech effectively, and build developer trust through content.',
  },
  {
    id: 'open-source-contributors',
    title: 'Open Source Contributors',
    description:
      'Open Source Contributors can learn best practices for collaboration, code sharing, and contributing effectively to community projects.',
  },
  {
    id: 'tech-enthusiasts-beginners',
    title: 'Tech Enthusiasts & Beginners',
    description:
      'Tech Enthusiasts can explore the latest trends, experiment with new tools, and gain a deeper understanding of how technology shapes products and experiences',
  },
];
